import { apiClient } from '../client';

/**
 * Endpoints relacionados a documentos
 */

/**
 * Faz upload de múltiplos documentos para um aluno
 * @param {FormData} formData - FormData com documentos e metadados
 * @returns {Promise<Object>} Resultado do upload
 */
const uploadDocuments = async (formData) => {
  const { data } = await apiClient.post('/documents/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

/**
 * Faz upload de um chunk de um documento
 * @param {FormData} formData - FormData com chunk e metadados
 * @returns {Promise<Object>} Resultado do upload do chunk
 */
const uploadDocumentChunk = async (formData) => {
  const { data } = await apiClient.post('/documents/upload-chunks', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

/**
 * Obtém o status de upload de um arquivo em chunks
 * @param {string} fileId - ID único do arquivo
 * @returns {Promise<Object>} Status do upload
 */
const getUploadStatus = async (fileId) => {
  const { data } = await apiClient.get(`/documents/upload-status/${fileId}`);
  return data;
};

/**
 * Cancela um upload de arquivo em chunks
 * @param {string} fileId - ID único do arquivo
 * @returns {Promise<Object>} Resultado do cancelamento
 */
const cancelUpload = async (fileId) => {
  const { data } = await apiClient.delete(`/documents/upload-cancel/${fileId}`);
  return data;
};

/**
 * Retorna a URL da pasta do aluno no Drive somente se a pasta existir.
 * Usado na consulta de documentos para exibir o ícone só quando há pasta válida.
 * @param {string} AlunoID - ID do aluno no Sponte
 * @returns {Promise<{ folderUrl: string | null }>}
 */
const getFolderUrlIfExists = async (AlunoID) => {
  let unit = null;
  try {
    const u = sessionStorage.getItem('loggedUser');
    if (u) unit = JSON.parse(u)?.unit ?? null;
  } catch {
    // ignora
  }
  const { data } = await apiClient.post('/documents/folder-url', { AlunoID, unit });
  return data;
};

export {
  uploadDocuments,
  uploadDocumentChunk,
  getUploadStatus,
  cancelUpload,
  getFolderUrlIfExists,
};

